
import { DistanceDisplayCondition, HorizontalOrigin,
  LabelStyle, Cartesian3,
  Cartesian2, Color as CesiumColor, CustomDataSource, VerticalOrigin } from "cesium/Cesium";

let LableLayer = function(jsonData, params) {
  this.source = new CustomDataSource("lableDataSouce");
  this.params = params;
  this._loadData(jsonData);
};

LableLayer.prototype = {
  _colorValue(c) {
    let c1 = [c[0] / 255, c[1] / 255, c[2] / 255, c[3]];
    return c1;
  },
  _loadData(data) {
    data.features.forEach(f => {
      let style = this.getStyleByProperty(f);
      let name = f.properties.name;
      let height = f.properties.height;
      let coords = f.geometry.coordinates;
      this.addLable(name, coords, height, style);
    });
  },
  getStyleByProperty(f) {
    let style = {};
    this.params.styles.forEach(s => {
      if (s.value === f.properties[this.params.propertyName]) {
        style.iconUrl = s.iconUrl;
        style.iconScale = s.iconScale;
        style.font = s.font;
        let fillColor = this._colorValue(s.fillColor);
        style.fillColor = new CesiumColor(fillColor[0], fillColor[1], fillColor[2], fillColor[3]);
        let outlineColor = this._colorValue(s.outlineColor);
        style.outlineColor = new CesiumColor(outlineColor[0], outlineColor[1], outlineColor[2], outlineColor[3]);
        style.outlineWidth = s.outlineWidth;
        style.distanceDisplay = new DistanceDisplayCondition(s.distanceDisplay[0], s.distanceDisplay[1]);
      }
    });
    return style;
  },
  addLable(name, coords, height, style) {
     let lable = {
       position: Cartesian3.fromDegrees(coords[0], coords[1], height),
       billboard: {
          scale: style.iconScale,
          verticalOrigin: VerticalOrigin.BOTTOM,
          distanceDisplayCondition: style.distanceDisplay,
          // heightReference: HeightReference.CLAMP_TO_GROUND,
          pixelOffset: new Cartesian2(-3, -0),
          horizontalOrigin: HorizontalOrigin.RIGHT,
          image: style.iconUrl
        },
        label: {
          distanceDisplayCondition: style.distanceDisplay,
          // heightReference: HeightReference.RELATIVE_TO_GROUND,
          text: name,
          horizontalOrigin: HorizontalOrigin.LEFT,
          verticalOrigin: VerticalOrigin.BOTTOM,
          // pixelOffset: new Cartesian2(0.0, 0.0),
          font: style.font,
          fillColor: style.fillColor,
          outlineColor: style.outlineColor,
          outlineWidth: style.outlineWidth,
          style: LabelStyle.FILL_AND_OUTLINE
        }
    };
    this.source.entities.add(lable);
  }

};

export default LableLayer;
